import { CommonGoalType } from "./CommonGoal"
import { IndividualGoalType } from "./IndividualGoal";

import closeIcon from '../images/close-icon.svg'
import Deadline from "../deadline";
import { useEffect } from "react";

interface GoalDetailProps {
    goalIdTarget: number;
    commonGoalList?: CommonGoalType[];
    individualGoalList?: IndividualGoalType[];
    handleClickClose: () => void;
}

export default function GoalDetail({ goalIdTarget, commonGoalList, individualGoalList, handleClickClose }: GoalDetailProps) {

    const commonGoalTarget = commonGoalList?.find(goal => goal.id === goalIdTarget)
    const individualGoalTarget = individualGoalList?.find(goal => goal.id === goalIdTarget)

    const deadlineDate = new Deadline(new Date(commonGoalTarget?.deadline || ''))

    const handleBackDropClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (e.target === e.currentTarget) {
            handleClickClose()
        }
    }

    return (
        <div className="ProgressDialog center" onClick={handleBackDropClick}>

            <div className="ProgressDialog-dialog">
                <button className="ProgressDialog-close-button" onClick={handleClickClose} >
                    <img src={closeIcon} width={24} height={24} alt="close-icon" />
                </button>
                <div className="ProgressDialog-goal-title-container">
                    <h4>{commonGoalTarget?.goal || individualGoalTarget?.goal || individualGoalTarget?.name}</h4>
                </div>
                <p className="ProgressDialog-goal-desc">{commonGoalTarget?.description || individualGoalTarget?.description || <i>- ไม่มีคำอธิบาย -</i>}</p>
                {commonGoalTarget &&
                    <div className="ProgressDialog-deadline" style={{ color: deadlineDate.deadlineColor }}>
                        <h5 className="CommonGoal-date">{deadlineDate.deadline}</h5>
                        <div className="flex gap-dot25">
                            <img src={deadlineDate.srcIcon} alt="" />
                            <h5 className="CommonGoal-countdown">{deadlineDate.diffDaysText}</h5>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}
